

































import { Component, Prop, Vue } from 'vue-property-decorator'

// components
import Dialog from '@/components/modals/Dialog.vue'
import FireworksStatsAnimation from '@/components/animations/FireworksStatsAnimation.vue'
import ModalWrapper from '@/components/modals/ModalWrapper.vue'
// store
import { StatisticsResource } from '@/store/types'
// utils
import { declension } from '@/utils/functions'

@Component({
  components: {
    Dialog,
    FireworksStatsAnimation,
    ModalWrapper,
  },
})
export default class StatisticModal extends Vue {
  @Prop({ default: false })
  private visible!: boolean

  @Prop({ required: true })
  private stat!: StatisticsResource

  // Отсутствует ли статистика
  private get isNoStat() {
    if (!this.stat)
      return true
    return !this.stat.lessons && !this.stat.exercises
  }

  private get declensionLessons() {
    return declension(this.stat.lessons, ['урок', 'урока', 'уроков'])
  }

  private get declensionExercises() {
    return declension(this.stat.exercises, ['домашнее задание', 'домашних задания', 'домашних заданий'])
  }

  private get subjectsList() {
    if (this.stat.subjects.length === 1) {
      return this.stat.subjects[0]
    }

    if (this.stat.subjects.length === 2) {
      return `${this.stat.subjects[0]} и ${this.stat.subjects[1]}`
    }

    if (this.stat.subjects.length > 2) {
      const last = this.stat.subjects.pop()
      return `${this.stat.subjects.join(', ')} и ${last}`
    }

    return ''
  }

  private handleClose() {
    setTimeout(() => {
      this.$emit('update:visible', false)
      this.$emit('completeStats')
    }, 1300)
  }
}
